import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { addTermsandcondition } from "../../../redux/termsandcondition/action";
import Spinner from "../../Layouts/Spinner";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";

const formData = [
  { title: "Type", name: "type" },
  { title: "Description", name: "description" },
  { title: "Arabic Description", name: "ar_description" },
  { title: "Status", name: "status" },
];

const AddTermsCondition = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const dispatch = useDispatch();
  const selectedOffer = {};
  const navigate = useNavigate();

  const initialValues = formData.reduce((acc, field) => {
    acc[field.name] = selectedOffer?.[field.name] || "";
    return acc;
  }, {});

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => handleSubmit(values),
    enableReinitialize: true,
  });

  const handleSubmit = (values) => {
    setLoading(true);
    const data = {
      ...values,
      id: id,
    };
    dispatch(addTermsandcondition(data, setLoading));
    setUpdate(false);
    setLoading(false);
  };

  return (
    <Card>
      <AddUpdateHeader
        modal={"Add Terms & Condition"}
        list={"Terms & Condition List"}
      />
      <CardBody className="">
        <form onSubmit={formik.handleSubmit}>
          <Row className="mx-2">
            {formData.map((prop, key) => {
              if (prop.name === "status") {
                const options = [
                  { value: 1, label: t("Active") },
                  { value: 2, label: t("Inactive") },
                ];

                return (
                  <Col className=" " xs={3} key={key}>
                    <label>{t(prop.title)}</label>
                    <div>
                      <ReactSelect
                        value={options.find(
                          (option) =>
                            option.value === formik.values?.[prop.name],
                        )}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(option) => {
                          formik.setFieldValue("status", option?.value);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {t(formik.errors[prop.name])}
                          </div>
                        )}
                    </div>
                  </Col>
                );
              }

              return (
                <Col className=" " key={key} xs={3}>
                  <div>
                    <label>{t(prop.title)}</label>
                    <CustomInput
                      type={prop.name === "type" ? "text" : "text"}
                      value={formik.values?.[prop.name]}
                      placeholder={prop.title}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                  </div>
                  {formik.touched[prop.name] && formik.errors[prop.name] && (
                    <div className="error">{t(formik.errors[prop.name])}</div>
                  )}
                </Col>
              );
            })}
            <Col xs={12} className="text-center my-3 d-flex align-items-center justify-content-between">
              <span
                disabled={loading}
                onClick={() => navigate(-1)}
                type="button"
              >
                Back
              </span>
              <Button disabled={loading} type="submit">
                {!loading ? (
                  selectedOffer?.id ? (
                    "Update"
                  ) : (
                    "Submit"
                  )
                ) : (
                  <Spinner />
                )}
              </Button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
};

export default AddTermsCondition;
